"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marginalBold = exports.marginal = exports.bodySmallBold = exports.bodySmall = exports.bodyMediumBold = exports.bodyMedium = exports.titleSmall = exports.titleMedium = exports.titleLarge = exports.headlineMedium = exports.headlineLarge = void 0;
exports.headlineLarge = {
    fontSize: 'var(--encore-text-size-larger-5)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 800,
};
exports.headlineMedium = {
    fontSize: 'var(--encore-text-size-larger-4)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
exports.titleLarge = {
    fontSize: 'var(--encore-text-size-larger-3)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
exports.titleMedium = {
    fontSize: 'var(--encore-text-size-larger-2)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
exports.titleSmall = {
    fontSize: 'var(--encore-text-size-larger)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
exports.bodyMedium = {
    fontSize: 'var(--encore-text-size-base)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 400,
};
exports.bodyMediumBold = {
    fontSize: 'var(--encore-text-size-base)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
exports.bodySmall = {
    fontSize: 'var(--encore-text-size-smaller)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 400,
};
exports.bodySmallBold = {
    fontSize: 'var(--encore-text-size-smaller)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
exports.marginal = {
    fontSize: 'var(--encore-text-size-smaller-2)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 400,
};
exports.marginalBold = {
    fontSize: 'var(--encore-text-size-smaller-2)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
